<div class="modal-header">
    <h5 class="modal-title">Rider Attendance</h5>
    <div class="ad-table-top-controll p-2 d-flex justify-content-end">
        <div class="md-tab-view">
            <div class="p-2 d-flex justify-content-end align-items-center ad-delivery-staff-form ad-from-to-date">
                <div class="form-group svg-calendar-none mb-0">
                    <label class="control-label">From date</label>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#444444">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 8H4v8h16v-8zm-5-6H9v2H7V5H4v4h16V5h-3v2h-2V5zm-9 8h2v2H6v-2zm5 0h2v2h-2v-2zm5 0h2v2h-2v-2z" />
                    </svg>
                    <div class="input-group" data-target-input="nearest">
                        <dp-date-picker theme="dp-material" [(ngModel)]="fromDate" placeholder="DD-MM-YYYY" mode="day"
                            [config]="datePickerConfig">
                        </dp-date-picker>
                    </div>
                </div>
                <div class="form-group svg-calendar-none ml-1 mb-0">
                    <label class="control-label">To date</label>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#444444">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8zM6 14h2v2H6v-2zm4 0h8v2h-8v-2z" />
                    </svg>
                    <div class="input-group" data-target-input="nearest">
                        <dp-date-picker theme="dp-material" placeholder="DD-MM-YYYY" mode="day"
                            [config]="datePickerConfig1" [(ngModel)]="toDate">
                        </dp-date-picker>
                    </div>
                </div>
                <button class="btn btn-custom-primary ml-1" type="button" (click)="getOneDailyDeploymentList()"><i
                        data-feather="search"></i>
                    Search</button>
                <button type="button" class="close ml-4" data-dismiss="modal" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!-- <div class="media align-items-center">
                <div class="ad-media-icons align-self-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path
                            d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 14V16H6V14H8ZM18 14V16H10V14H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z">
                        </path>
                    </svg>
                </div>
                <div class="media-body">
                    <p class="mt-0 mb-0">From - To date</p>
                    <h5 class="mb-0">
                        {{fromDate | dateFormat: constant.DateFormatHtml}} - {{toDate | dateFormat:
                        constant.DateFormatHtml}}
                    </h5>
                </div>
                <button type="button" class="close ml-4" data-dismiss="modal" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> -->
        </div>
    </div>
</div>
<div class="modal-body p-0">
    <div class="best-seller-table responsive-tbl">
        <div class="item">
            <div class="table-responsive product-list">

                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Delivery staff</th>
                            <th>Phone number</th>
                            <th>Ds type</th>
                            <th>Date</th>
                            <th>{{'Master.Vendor' | translate}} name</th>
                            <th>Reached time</th>
                            <th>Verified by</th>
                            <th>Start time</th>
                            <th>End time</th>
                        </tr>
                    </thead>
                    <tbody class="text-center font-primary empty-image-container" *ngIf="!dailyDeploymentList?.length">
                        <tr>
                            <td colspan="13">
                                <div class="empty-item">
                                    <div class="empty-data">
                                        <img src="assets/images/icons/empty-order.png" alt="Empty image">
                                        <h6>The list is empty</h6>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="dailyDeploymentList?.length">
                        <tr *ngFor="let dd of dailyDeploymentList; let i=index">
                            <td>
                                {{dailyDeploymentPagination.currentPageFirstSlNo+i}}</td>
                            <td> {{(dd?.DeliveryStaff?.full_name)?(dd?.DeliveryStaff?.full_name):'---'}}
                            </td>
                            <td>{{(dd?.DeliveryStaff?.phone)?(dd?.DeliveryStaff?.phone):'---'}}</td>
                            <td>{{dd?.part_full_time}}</td>
                            <td>{{dd?.date | dateFormat: constant.DateFormatHtml}}</td>
                            <td>{{(dd?.Vendor?.full_name)?(dd?.Vendor?.full_name):'---'}}</td>
                            <td>{{dd?.reached_time | dateFormat: constant.DateFormatWithTimeHtml}}</td>
                            <td>{{dd?.reach_verified_by}}</td>
                            <td>{{dd?.start_date_time}}</td>
                            <td>{{dd?.end_date_time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

    <div class="row row--gutter" *ngIf="dailyDeploymentPagination">
        <div class="col-xl-12 d-flex">
            <div class="pagination-wrapper">
                <ngb-pagination class="inline-block" [collectionSize]="dailyDeploymentPagination.totalRows"
                    [pageSize]="dailyDeploymentPagination.rowSize" [maxSize]="5" [ellipses]="false"
                    [(page)]="dailyDeploymentPagination.currentPage" [rotate]="true" (pageChange)="loadPage($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>